var map = {
	"./carousel_item_azts.png": 7323,
	"./carousel_item_cwjz.png": 777,
	"./carousel_item_gclqd.png": 4119,
	"./carousel_item_gcsj.png": 45,
	"./carousel_item_gjfw.png": 3059,
	"./carousel_item_jjbzx.png": 6775,
	"./carousel_item_jjfa.png": 1375,
	"./carousel_item_jsbzx.png": 2164,
	"./carousel_item_pjbl.png": 4140,
	"./carousel_item_rkjba.png": 9285,
	"./carousel_item_sbyw.png": 1171,
	"./carousel_item_spzz.png": 3012,
	"./carousel_item_swbzx.png": 697,
	"./carousel_item_tbsb.png": 3765,
	"./carousel_item_twsj.png": 4351,
	"./carousel_item_xcbm.png": 2395,
	"./carousel_item_xckc.png": 8893,
	"./carousel_item_xmgl.png": 5569,
	"./carousel_item_xqgt.png": 3779,
	"./carousel_item_xsbf.png": 9356,
	"./carousel_item_zjscc.png": 6989,
	"./carousel_item_zlbx.png": 2273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2389;